import React, {PropTypes as T} from 'react';
import Modal from '../../common/modal';
import Recaptcha from './recaptcha';
import Error from './error_message';
import noScroll from '../../../utils/noscroll';

export default class MFOLRecaptcha extends React.Component {
  static propTypes = {
    onClose: T.func,
    siteKey: T.string,
    verifyEndpoint: T.string,
    onSuccess: T.func
  };

  static defaultProps = {
    onClose: Function.prototype
  };

  state = {
    isOpen: true
  };

  getGrecaptcha = () => {
    if (window && window.grecaptcha) {
      return window.grecaptcha;
    }
  };

  closeModal = () => {
    this.setState({ isOpen: false }, () => {
      noScroll.off();
      setTimeout(this.props.onClose, 300);
    });
  };

  onAfterOpen = () => {
    noScroll.off();
  };

  render () {
    var grecaptcha = this.getGrecaptcha();

    return (
      <Modal
        dataComponent="recaptcha-modal"
        isOpen={this.state.isOpen}
        onClose={this.closeModal}
        onAfterOpenModal={this.onAfterOpen}>
        {!!grecaptcha && <Recaptcha
          onClose={this.closeModal}
          verifyEndpoint={this.props.verifyEndpoint}
          onSuccess={this.props.onSuccess}
          siteKey={this.props.siteKey} />}
        {!grecaptcha && <Error onClose={this.closeModal} />}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/recaptcha/index.js